import { createAction } from '@reduxjs/toolkit';

import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

// Login
export const postForgotPasswordRequest = createAction('postForgotPasswordRequest');
export const postForgotPasswordSuccess = createAction('postForgotPasswordSuccess');
export const postForgotPasswordFailure = createAction<string>('postForgotPasswordFailure');

export const postForgotPassword = (postBody: RequestModel) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(postForgotPasswordRequest());

    try {
        await api.post('admin/auth/forgot-password', postBody);
        dispatch(postForgotPasswordSuccess());
    } catch (e) {
        handleApiErrors(dispatch, postForgotPasswordFailure, e);
    }
};

interface RequestModel {
    email: string;
}
